import * as env from '@paperstac/env';
import { init as firebaseInit } from '@paperstac/firebase/lib/firebaseClient';

firebaseInit(env);
